import React from 'react';
import { useLang } from '../context/LanguageContext';
import PageHero from '../components/PageHero';
import CTASection from '../components/CTASection';
import { Target, Eye, Award, Users, Globe, Compass, ShieldCheck, Sparkles } from 'lucide-react';

const About = () => {
  const { t } = useLang();
  const valueIcons = [Sparkles, ShieldCheck, Compass, Globe];
  return (
    <div>
      <PageHero title={t.about.title} desc={t.about.lead} />
      <section className="bg-white py-20">
        <div className="sib-container grid md:grid-cols-2 gap-8">
          {[t.about.mission, t.about.vision].map((b, i) => (
            <div key={i} className="bg-[#FBF9F2] border border-[#E8E1CE] rounded-lg p-8 card-hover">
              <div className="w-12 h-12 rounded-md bg-[#0B5D3B]/10 flex items-center justify-center mb-4">{i === 0 ? <Target className="w-6 h-6 text-[#0B5D3B]" /> : <Eye className="w-6 h-6 text-[#0B5D3B]" />}</div>
              <h3 className="text-2xl font-bold text-[#0B5D3B] mb-3">{b.title}</h3>
              <p className="text-[#33473d]/85 leading-relaxed">{b.desc}</p>
            </div>
          ))}
        </div>
      </section>
      <section className="bg-[#FBF9F2] py-20">
        <div className="sib-container">
          <h2 className="section-title text-center mb-12">{t.about.values.title}</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
            {t.about.values.items.map((v, i) => {
              const Icon = valueIcons[i];
              return (
                <div key={i} className="bg-white border border-[#E8E1CE] rounded-lg p-6 card-hover">
                  <div className="w-11 h-11 rounded-md bg-[#D4A840]/15 flex items-center justify-center mb-3"><Icon className="w-5 h-5 text-[#D4A840]" /></div>
                  <h4 className="font-semibold text-[#0B5D3B] mb-2 text-[15px]">{v.t}</h4>
                  <p className="text-[13px] text-[#33473d]/80 leading-relaxed">{v.d}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>
      <section className="bg-white py-20">
        <div className="sib-container max-w-3xl mx-auto text-center">
          <h2 className="section-title mb-6">{t.about.story.title}</h2>
          <p className="text-[#33473d]/85 leading-relaxed text-lg">{t.about.story.desc}</p>
        </div>
      </section>
      <CTASection />
    </div>
  );
};
export default About;
